import { LockIcon } from 'lucide-react';
import { Trans } from 'react-i18next';

import ExternalLink from '@/components/ui/external-link';

const InstitutionLockedAnswersNotice = () => {
  return (
    <p className="flex gap-2 text-sm text-muted-foreground">
      <LockIcon aria-hidden className="size-4 shrink-0 mt-0.5" />
      <span>
        <Trans
          i18nKey="institutionDetails.update.locked"
          components={[
            <ExternalLink key="institutionDetails.update.locked.contactSupport" className="underline hover:no-underline" href={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL} />,
          ]}
        />
      </span>
    </p>
  );
};
InstitutionLockedAnswersNotice.displayName = 'InstitutionLockedAnswersNotice';

export default InstitutionLockedAnswersNotice;
